export function loadGoogleFont(fontName) {
  const fontSlug = fontName.replace(/\s+/g, '+');
  const id = `google-font-${fontSlug}`;
  if (document.getElementById(id)) return;

  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${fontSlug}&display=swap`;
  document.head.appendChild(link);
}
